import script from "./CustomersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomersView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomersView.vue?vue&type=style&index=0&id=cfb2043e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfb2043e"]])

export default __exports__